function normalizeAgentName(name: string) {
    return name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
}

/** Lifted Valorant identity colors (backgroundGradientColors), with brand overrides where the cinematic wash is misleading. */
const AGENT_ACCENT: Record<string, string> = {
    astra: "#5330d9",
    breach: "#d65b33",
    brimstone: "#e09a3e",
    chamber: "#d4b45a",
    clove: "#7f37d2",
    cypher: "#4a7fbf",
    deadlock: "#4a63bf",
    fade: "#4a69bf",
    gekko: "#b6d14a",
    harbor: "#4abfa1",
    iso: "#4a50bf",
    jett: "#439ec6",
    kayo: "#3e58cb",
    killjoy: "#e6c84a",
    miks: "#754abf",
    neon: "#3cf0ff",
    omen: "#684abf",
    phoenix: "#cf5f3a",
    raze: "#cd573d",
    reyna: "#bf4ab7",
    sage: "#4abfaa",
    skye: "#4abf74",
    sova: "#4a74bf",
    tejo: "#d47735",
    veto: "#3cbdcd",
    viper: "#3fca98",
    vyse: "#793ecc",
    waylay: "#864abf",
    yoru: "#4757c2",
};

export function agentAccent(name?: string | null): string | undefined {
    if (!name) return undefined;
    return AGENT_ACCENT[normalizeAgentName(name)];
}

export function hexRgba(hex: string, alpha: number) {
    const n = hex.replace("#", "");
    const r = parseInt(n.slice(0, 2), 16);
    const g = parseInt(n.slice(2, 4), 16);
    const b = parseInt(n.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function agentRowSx(color?: string) {
    if (!color) return {};
    return {
        background: `linear-gradient(90deg, ${hexRgba(color, 0.22)} 0%, ${hexRgba(color, 0.1)} 36%, ${hexRgba(color, 0.03)} 100%)`,
        border: `1px solid ${hexRgba(color, 0.22)}`,
        "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "3px",
            borderRadius: "6px 0 0 6px",
            background: color,
            boxShadow: `0 0 10px ${color}`,
            zIndex: 3,
            pointerEvents: "none",
        },
        "&:hover": {
            background: `linear-gradient(90deg, ${hexRgba(color, 0.3)} 0%, ${hexRgba(color, 0.14)} 40%, ${hexRgba(color, 0.05)} 100%)`,
            border: `1px solid ${hexRgba(color, 0.38)}`,
        },
    };
}
